<template>
  <router-view />
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  data() {
    return {
      deviceInfo:
        navigator.userAgent.match(/MesDeviceInfo\[[^\]]*\]/)?.[0] ?? "",
    };
  },
});
</script>
